<div class="map-venue">
    <div *ngIf="!venue; else divInfoBusiness" class="loading-container-panel h-100 w-100 d-flex justify-content-center">
        <div class="container-lottie">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>
    <ng-template #divInfoBusiness>
        <div>
            <!-- Aforo y botón crear: solo visibles si NO venimos de /create-map/ -->
            <ng-container *ngIf="!fromCreate">
                <!-- Aforo -->
                <div class="container-in-page container-capacity" *ngIf="!map">
                    <div class="input-capacity-event">
                        <div class="title-edit">
                            <i class="fa-light fa-seat-airline"></i>
                            <p class="m-0">Aforo del espacio</p>
                        </div>
                        <div class="d-flex align-items-center edit-capacity">
                            <input class="w-100" [disabled]="!editCapacity" type="number"
                                placeholder="Indica el aforo del espacio" [(ngModel)]="capacity" name="link">
                            <i class="fal" [class]="editCapacity ? 'fa-save icon-primary' : 'fa-pen'"
                                (click)="changeCapacity()"></i>
                        </div>
                    </div>
                </div>
                <!-- Mapa de butacas -->
                <div class="container-in-page d-grid" *ngIf="!map">
                    <div class="title-edit">
                        <p class="m-0">Mapa de butacas</p>
                    </div>
                    <p *ngIf="!map && !openedCreateMap">Para crear un mapa de butacas, por favor, ponte en contacto
                        con los administradores de Citylok.</p>
                    <div class="conteiner-map-venue" *ngIf="isSuperAdmin">
                        <div class="btns-create">
                            <div class="btn-create btn-bono m-0" (click)="createMap()">
                                <i class="fal fa-plus-circle"></i>
                                <p class="m-0">Crear mapa de butacas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- Canvas del mapa -->
            <div class="container-map-venue" *ngIf="map || openedCreateMap">
                <!-- Botón editar mapa: solo superadmin, solo en modo vista (map-venue route) -->
                <div class="d-flex justify-content-end mb-2 gap-2" *ngIf="isSuperAdmin && !fromCreate && map">
                    <div class="btn-create btn-bono m-0" (click)="regenerateDefaultTickets()">
                        <i class="fal fa-ticket"></i>
                        <p class="m-0">Regenerar entrada general</p>
                    </div>
                    <div class="btn-create btn-bono m-0" (click)="editMap()">
                        <i class="fal fa-pen"></i>
                        <p class="m-0">Editar mapa</p>
                    </div>
                </div>
                <!-- Botón editar mapa: en ruta create-map, antes de activar edición -->
                <div class="d-flex justify-content-end mb-2" *ngIf="isSuperAdmin && fromCreate && !isEditingMap">
                    <div class="btn-create btn-bono m-0" (click)="startEditMap()">
                        <i class="fal fa-pen"></i>
                        <p class="m-0">Editar mapa</p>
                    </div>
                </div>
                <app-create-map [capacity]="capacity" [fromVenue]="true" [fromCreate]="fromCreate" [venue]="venue" [map]="map" [blockedSeats]="blockedSeats"
                    [allowCreate]="isSuperAdmin && fromCreate && isEditingMap" [isSaving]="isSaving" (save)="saveMapVenue()"></app-create-map>
            </div>
        </div>
    </ng-template>
</div>